import { Box } from "@mui/material"

import { MAIN_PAGE_BG } from "@constants/colors"
import { useChangelogPageContext } from "@contexts/main/changelog_page_context"

import ChangelogDrawer from "./sub_components/announcement_drawer"
import AnnouncementDetailDrawer from "./sub_components/announcement_detail_drawer"
import AnnouncementsSection from "./sub_components/announcements"
import CategoriesSection from "./sub_components/categories"
import CategoryDialog from "./sub_components/category_dialog"
import DeleteCategoryDialog from "./sub_components/delete_category_dialog"
import DeliveriesSection from "./sub_components/deliveries"
import PreviewDrawer from "./sub_components/preview_drawer"
import SendNotificationDialog from "./sub_components/send_notification_dialog"
import SettingsSection from "./sub_components/settings"
import SubscribersSection from "./sub_components/subscribers"

export default function ChangelogPage() {
  const { activeSection } = useChangelogPageContext()

  return (
    <Box
      sx={{
        height: "100%",
        overflow: "auto",
        background: MAIN_PAGE_BG,
        px: 4,
        py: 3
      }}
    >
      {activeSection === "announcements" && <AnnouncementsSection />}
      {activeSection === "categories" && <CategoriesSection />}
      {activeSection === "subscribers" && <SubscribersSection />}
      {activeSection === "deliveries" && <DeliveriesSection />}
      {activeSection === "settings" && <SettingsSection />}

      {/* Global overlays — available from any section */}
      <ChangelogDrawer />
      <AnnouncementDetailDrawer />
      <SendNotificationDialog />
      <PreviewDrawer />
      <CategoryDialog />
      <DeleteCategoryDialog />
    </Box>
  )
}
